// extracted by mini-css-extract-plugin
module.exports = {"singlePostWrap":"SinglePostWrap_singlePostWrap__hcAvd"};